import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["unread", "read"]

  connect() {
    this.observe()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  observe() {
    // Watch for the turbo frame to load and check for unread indicator
    this.observer = new MutationObserver(() => this.checkUnread())
    this.observer.observe(this.element, { childList: true, subtree: true })

    // Also check immediately in case frame is already loaded
    this.checkUnread()
  }

  checkUnread() {
    const unreadIndicator = this.element.querySelector('[data-unread="true"]')
    if (unreadIndicator) {
      this.element.classList.remove(this.readClass)
      this.element.classList.add(this.unreadClass)
    } else if (this.element.querySelector('[data-unread="false"]')) {
      this.markAsRead()
    }
  }

  markAsRead() {
    this.element.classList.remove(this.unreadClass)
    this.element.classList.add(this.readClass)
  }
}
